import { render, staticRenderFns } from "./CkeditorForChat.vue?vue&type=template&id=34f98ed8&scoped=true"
import script from "./CkeditorForChat.vue?vue&type=script&lang=js"
export * from "./CkeditorForChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f98ed8",
  null
  
)

export default component.exports